import { Logo } from "@/components/display";
import { Box, Stack, StackProps, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useMemo } from "react";

export interface PrintComponentHeaderProps extends StackProps{
    title:string
}

export default function PrintComponentHeader({
    title,
    ...props
}:PrintComponentHeaderProps) {
    const dateString = useMemo(() => {
        return dayjs().format("DD/MM/YYYY");
    }, [])

    return <Stack gap={1} {...props}>
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"start"}>
            <Logo />
            <Typography fontSize={"0.75rem"}>
                <Box component={"span"} fontWeight={"bold"}>Generado en:</Box> {dateString}
            </Typography>
        </Stack>

        <Stack direction={"row"} alignItems={"center"} justifyContent={"center"}>
            <Typography variant="h6" component={"h1"} >{title}</Typography>
        </Stack>
    </Stack>
}